// ProjectCard.js
import React from 'react';

const Projects = () => {

  const projectData = [
    {
      title: "Smart Canteen Management System",
      description: "A web application built using HTML, CSS, JavaScript, and MySQL to manage canteen orders and inventory effectively.",
      link: "https://canteen.kamarajengg.edu.in/",
      linkText: "Live Demo"
    },
    {
      title: "Smart Car Parking System using IoT",
      description: "An IoT-based project designed to optimize parking space usage and automate parking systems for better efficiency.",
      link: "https://github.com/Malaiappan59/smart_car_Parking_using-IoT",
      linkText: "GitHub Repository"
    },
    {
      title: "Password Strength Checker App",
      description: "An application built using HTML, CSS, and jQuery to check the strength of passwords and provide feedback to users.",
      link: "https://github.com/Malaiappan59/Password_Strength_checker",
      linkText: "GitHub Repository"
    }
  ];

  return (
    <section id='projects' className=" bg-[#522258] text-white flex flex-col items-center pb-24 ">
      <h2 className='py-20 md:text-3xl text-xl font-extrabold'>Projects</h2>
      <div className='flex md:flex-row flex-col md:w-full w-[90%] md:gap-16 gap-8'>
      {projectData.map((project, index) => (
        
        <div 
          key={index} 
          className="max-w-sm mx-auto bg-[#8C3061] shadow-lg rounded-lg overflow-hidden border border-gray-200 hover:shadow-2xl transition-shadow duration-300 "
        >
          <div className="p-6">
            <h2 className="md:text-2xl text-lg font-semibold text-white">{project.title}</h2>
            <p className="text-white mt-2 md:text-base text-sm">{project.description}</p>
            <a 
              href={project.link} 
              target="_blank" 
              rel="noopener noreferrer"
              className="md:text-base text-sm inline-block mt-4 px-4 py-2 text-white bg-[#C63C51] rounded-lg hover:bg-[#7e2835] transition-colors duration-200"
            >
              {project.linkText}
            </a>
          </div>
        </div>
        
      ))}
      </div>
    </section>
    
  );
};

export default Projects;
